export default "__VITE_ASSET__BnJRlm2x__"